
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class extends Vue {
  private loading = false
  private tag: any = {
    0: { text: '待回复', color: 'red' },
    1: { text: '已回复', color: 'green' },
  }
  private num = 0
}
